import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMapPin, FiUsers, FiArrowRight, FiShield } = FiIcons;

function PrisonSelection({ selectedPrison, setSelectedPrison }) {
  const navigate = useNavigate();
  const { prisons } = useApp();

  const handlePrisonSelect = (prison) => {
    setSelectedPrison(prison);
    navigate('/customer/order-form');
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-8"
      >
        <h1 className="text-3xl font-bold text-government-900 dark:text-white mb-4">
          Select Prison to Visit
        </h1>
        <p className="text-government-600 dark:text-government-300 text-lg">
          Choose the prison you'll be visiting to view their available menu
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {prisons.map((prison, index) => (
          <motion.div
            key={prison.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white dark:bg-government-800 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
            onClick={() => handlePrisonSelect(prison)}
          >
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="bg-primary-100 dark:bg-primary-900 p-3 rounded-lg">
                  <SafeIcon icon={FiShield} className="w-6 h-6 text-primary-600 dark:text-primary-400" />
                </div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                  prison.type === 'Category A' 
                    ? 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300'
                    : 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-300'
                }`}>
                  {prison.type}
                </span>
              </div>
              
              <h3 className="text-xl font-bold text-government-900 dark:text-white mb-2">
                {prison.name}
              </h3>
              
              <div className="space-y-2 mb-4">
                <div className="flex items-center text-government-600 dark:text-government-300">
                  <SafeIcon icon={FiMapPin} className="w-4 h-4 mr-2" />
                  <span className="text-sm">{prison.location}</span>
                </div>
                <div className="flex items-center text-government-600 dark:text-government-300">
                  <SafeIcon icon={FiUsers} className="w-4 h-4 mr-2" />
                  <span className="text-sm">Capacity: {prison.capacity}</span>
                </div>
              </div>
              
              <div className="flex items-center justify-between">
                <span className="text-sm text-government-500 dark:text-government-400">
                  Manager: {prison.manager}
                </span>
                <SafeIcon 
                  icon={FiArrowRight} 
                  className="w-5 h-5 text-primary-600 dark:text-primary-400 group-hover:translate-x-1 transition-transform"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default PrisonSelection;